var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoricUnlinkedTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17011 15.5801C8.98011 15.5801 8.79011 15.5101 8.64011 15.3601C8.35011 15.0701 8.35011 14.5901 8.64011 14.3001L14.3001 8.64011C14.5901 8.35011 15.0701 8.35011 15.3601 8.64011C15.6501 8.93011 15.6501 9.41011 15.3601 9.70011L9.70011 15.3601C9.56011 15.5101 9.36011 15.5801 9.17011 15.5801Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8301 15.5801C14.6401 15.5801 14.4501 15.5101 14.3001 15.3601L8.64011 9.70011C8.35011 9.41011 8.35011 8.93011 8.64011 8.64011C8.93011 8.35011 9.41011 8.35011 9.70011 8.64011L15.3601 14.3001C15.6501 14.5901 15.6501 15.0701 15.3601 15.3601C15.2101 15.5101 15.0201 15.5801 14.8301 15.5801Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricUnlinkedTask);
export default __webpack_public_path__ + "static/media/HistoricUnlinkedTask.e23548ef.svg";
export { ForwardRef as ReactComponent };